type SwitchBelowMinBuyParams = { estimate: string; product: string; min: string };

export const T = {
  en_GB: {
    searchPlaceholder: "Search by name or ISIN...",
    noProductsMatch: "No products match your search criteria.",
    units: "Units",
    save: "Save",
    belowMinBuy: "Below minimum",
    minBuyDialogHint: (min: string) => `Minimum buy for this product: ${min}`,
    switchBelowMinBuy: (p: SwitchBelowMinBuyParams) =>
      `This switch moves about ${p.estimate} into ${p.product}, below its minimum buy of ${p.min}. Switch more, or buy it with new money.`,
    // QL-283 — switch pairs
    close: "Close",
    switchDialogTitle: "Switch holding",
    switchDialogDescription: (name: string, held: string) =>
      `${name} — the client holds ${held}. Each pair sells a share of the holding and invests the proceeds in the chosen product; whatever is not covered by a pair is kept.`,
    switchAddPairLabel: "Add switch target",
    switchTargetPlaceholder: "Choose a product",
    switchNoEligibleTargets:
      "No eligible products — switch targets must be amount-based products, available for this goal and compatible with the source account's wrapper type.",
    switchAddPair: "Add",
    switchFullyAllocated:
      "The whole holding is already switched. Lower or remove a pair above to add another target.",
    switchNothingToSwitch: "This holding has no units to switch.",
    switchRemovePair: "Remove switch pair",
    switchReadOnlyHint: "Execution is tracked per order under the client's Orders tab.",
    switchClearAll: "Clear switch",
    switchRemainingHint: (remaining: string, unit: string) =>
      `${remaining} ${unit} of the holding remains unallocated (kept).`,
    switchValueInvalid: (max: string, unit: string) =>
      `Enter a whole number between 1 and ${max} ${unit}.`,
  },
  nb_NO: {
    searchPlaceholder: "Søk etter navn eller ISIN...",
    noProductsMatch: "Ingen produkter matcher søkekriteriene.",
    units: "Andeler",
    save: "Lagre",
    belowMinBuy: "Under minimum",
    minBuyDialogHint: (min: string) => `Minimumskjøp for dette produktet: ${min}`,
    switchBelowMinBuy: (p: SwitchBelowMinBuyParams) =>
      `Dette byttet flytter ca. ${p.estimate} inn i ${p.product}, under minstekjøpet på ${p.min}. Bytt mer, eller kjøp med nye penger.`,
    // QL-283 — bytte (switch)
    close: "Lukk",
    switchDialogTitle: "Bytt beholdning",
    switchDialogDescription: (name: string, held: string) =>
      `${name} — kunden eier ${held}. Hvert par selger en andel av beholdningen og investerer provenyet i valgt produkt; det som ikke dekkes av et par, beholdes.`,
    switchAddPairLabel: "Legg til byttemål",
    switchTargetPlaceholder: "Velg et produkt",
    switchNoEligibleTargets:
      "Ingen kvalifiserte produkter — byttemål må være beløpsbaserte produkter, tilgjengelige for dette målet og kompatible med kildekontoens kontotype.",
    switchAddPair: "Legg til",
    switchFullyAllocated:
      "Hele beholdningen er allerede byttet. Reduser eller fjern et par over for å legge til et nytt mål.",
    switchNothingToSwitch: "Denne beholdningen har ingen andeler å bytte.",
    switchRemovePair: "Fjern byttepar",
    switchReadOnlyHint: "Utførelsen følges per ordre under kundens Ordre-fane.",
    switchClearAll: "Fjern alle byttepar",
    switchRemainingHint: (remaining: string, unit: string) =>
      `${remaining} ${unit} av beholdningen er ikke allokert (beholdes).`,
    switchValueInvalid: (max: string, unit: string) =>
      `Angi et helt tall mellom 1 og ${max} ${unit}.`,
  },
} as const;
